module.exports = __webpack_public_path__ + "img/dcrl.a51129fd.jpg";